<template>
  <div>
    <div v-if="hasDifferences()" class="diff-container">
      <div class="diff-box diff-left-box">
        <div class="diff-box-title">
          <span>更新前</span>
        </div>
        <div
          v-for="(value, key) in fieldLabels"
          :key="key"
          class="diff-item"
          v-if="isDifferent(obj1, obj2, key)"
        >
          <span class="diff-label">{{ fieldLabels[key] }}:</span>
          <span
            class="diff-value"
            @click="handleClick(obj1, key)"
            :style="{
              cursor: cursorPointer.includes(fieldLabels[key])
                ? 'pointer'
                : 'default',
            }"
            >{{ getValue(obj1, key) }}</span
          >
        </div>
      </div>

      <div class="diff-change-box">
        <span>变更</span>
        <span class="diff-change-arrow">→</span>
      </div>

      <div class="diff-box diff-right-box">
        <div class="diff-box-title">
          <span>更新后</span>
        </div>
        <div
          v-for="(value, key) in fieldLabels"
          :key="key"
          class="diff-item"
          v-if="isDifferent(obj1, obj2, key)"
        >
          <span class="diff-label">{{ fieldLabels[key] }}:</span>
          <span
            :class="{ highlight: isDifferent(obj1, obj2, key) }"
            class="diff-value"
            @click="handleClick(obj2, key)"
            :style="{
              cursor: cursorPointer.includes(fieldLabels[key])
                ? 'pointer'
                : 'default',
            }"
          >
            {{ getValue(obj2, key) }}
          </span>
        </div>
      </div>
    </div>

    <div v-else class="no-differences">
      <p>没有检测到数据差异</p>
    </div>
  </div>
</template>

<script>
import { CURSOR_POINTER } from "@/components/auditPage/data.js";
export default {
  props: {
    obj1: Object,
    obj2: Object,
    fieldLabels: Object,
  },
  data() {
    return {
      cursorPointer: CURSOR_POINTER,
    };
  },
  methods: {
    handleClick(data, key) {
      this.$emit("preview", data, key);
    },
    hasDifferences() {
      return Object.keys(this.fieldLabels).some((key) =>
        this.isDifferent(this.obj1, this.obj2, key)
      );
    },
    getValue(obj, key) {
      const val = obj && obj[key];
      return val === null || val === undefined ? "" : val;
    },
    // 空串 / null / undefined 视为相同，避免「空→空」假差异
    normalizeEmpty(val) {
      if (val === null || val === undefined || val === "") return "";
      return val;
    },
    isDifferent(obj1, obj2, key) {
      const v1 = this.normalizeEmpty(obj1 && obj1[key]);
      const v2 = this.normalizeEmpty(obj2 && obj2[key]);
      return v1 !== v2;
    },
  },
};
</script>

<style scoped>
.diff-container {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.diff-box {
  border: 1px solid #e1e4e8;
  border-radius: 10px;
  padding: 20px;
  background: white;
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.diff-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.diff-left-box {
  border-top: 4px solid #e74c3c;
}

.diff-right-box {
  border-top: 4px solid #2ecc71;
}

.diff-box-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 8px;
}

.diff-left-box .diff-box-title {
  color: #e74c3c;
}

.diff-right-box .diff-box-title {
  color: #2ecc71;
}

.diff-change-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #7f8c8d;
  min-width: 80px;
}

.diff-change-arrow {
  font-size: 24px;
  color: #3498db;
}

.diff-item {
  display: flex;
  margin-bottom: 15px;
  align-items: flex-start;
  animation: fadeIn 0.5s ease;
}

.diff-item:last-child {
  margin-bottom: 0;
}

.diff-label {
  font-weight: 600;
  min-width: 100px;
  color: #2c3e50;
}

.diff-value {
  flex: 1;
  word-break: break-word;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f8f9fa;
}

.highlight {
  background-color: rgba(46, 204, 113, 0.15);
  color: #27ae60;
  font-weight: 500;
  animation: pulse 1.5s infinite;
}

.no-differences {
  text-align: center;
  color: #7f8c8d;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.footer {
  text-align: center;
  margin-top: 40px;
  color: #7f8c8d;
  font-size: 14px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    background-color: rgba(46, 204, 113, 0.15);
  }
  50% {
    background-color: rgba(46, 204, 113, 0.25);
  }
  100% {
    background-color: rgba(46, 204, 113, 0.15);
  }
}

@media (max-width: 768px) {
  .diff-container {
    flex-direction: column;
    align-items: center;
  }

  .diff-change-box {
    flex-direction: row;
    margin: 10px 0;
  }

  .diff-box {
    width: 100%;
  }
}
</style>
